const index = () => import('./pages/index')
const detail = () => import('./components/detail')

export default [
  {
    path: '/proposals',
    name: 'proposals.index',
    component: index,
    meta: { requiresAuth: true }
  },
  {
    path: '/proposals/:id/details',
    name: 'proposals.detail',
    component: detail,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/proposals/routes.js